import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-variables-values.types";
import { useInteractionVariablesValues } from "hooks-for/interactions/use-interaction-variables-values";
import InteractionDetailsItem from "../interaction-details-item";
import "./interaction-variables-values.scss";

/**
 * A component to display various variables stored on interactions
 * @param props.interactionId The ID of the interaction
 */
const InteractionVariablesValues: FunctionComponent<IProps> = ({ interactionId }) => {
    const { data: interactionVariablesValues } = useInteractionVariablesValues(interactionId);

    return (
        <table aria-label="interaction-variables-values" className="interaction-variables-values">
            <tbody>
                {(interactionVariablesValues ?? []).map((variableValue) => (
                    <InteractionDetailsItem
                        key={variableValue.interactionVariableId}
                        detailsLabel={variableValue.interactionVariable}
                        value={variableValue.value}
                        isInteractionDetailsLoading={false}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default memo(InteractionVariablesValues);
